import domWrap from '../utils/domWrap';
import h from '../utils/htm';
import http from '../utils/http';

const calculateResults = http('/FuelEfficiency/calculate').get;

export default async calc => {
	const	{default: wNumb} = await import('wnumb'),
			{default: noUiSlider} = await import('nouislider'),
			fields = calc.querySelector('[fields]'),
			results = calc.querySelector('[results]'),
			dollars = wNumb({
				prefix: '$',
				decimals: 0,
				thousand: ',',
				negativeBefore: '-'
			}),
			thousands = wNumb({
				decimals: 0,
				thousand: ','
			}),
			percent = wNumb({
				decimals: 1,
				thousand: ',',
				postfix: '%'
			}),
			defaults = {
				averageMPG: 7.0,
				averageDEFConsumed: 3.0,
				annualMileage: 100,
				fuelCost: 2.75,
				defCost: 2.75,
			},
			sliders = [
				{
					label: 'Average MPG',
					param: 'averageMPG',
					range: { min: 5.5, max: 8.5 },
					step: 0.1,
				},
				{
					label: 'DEF Consumed (% fuel used)',
					param: 'averageDEFConsumed',
					range: { min: 0, max: 4 },
					step: 0.1,
				},
				{
					label: 'Annual Mileage (Thousand)',
					param: 'annualMileage',
					range: { min: 25, max: 250 },
					step: 5,
					decimal: 0,
				},
				{
					label: 'Fuel Cost $ (per gallon)',
					param: 'fuelCost',
					range: { min: 2.25, max: 6.5 },
					step: 0.05,
				},
				{
					label: 'DEF Cost $ (per gallon)',
					param: 'defCost',
					range: { min: 1.5, max: 4 },
					step: 0.05,
				}
			],
			values = {};

	let engine = calc.querySelector('[tabs]')?.getAttribute('default') || 'DD15';
	
	sliders.forEach(slider => {
		const 	control = h('h4',slider.label)
					('div',
						h('button','-')
						('div class="range-field"')
						('button','+')
						('div class="result"')
					).Node,
				rangeField = control.querySelector('.range-field'),
				result = control.querySelector('.result'),
				container = domWrap(control.querySelector('div')),
				decimals = (slider.step.toString().split('.')[1] || []).length;

		noUiSlider.create(rangeField,{
			start: defaults[slider.param],
			range: slider.range,
			step: slider.step,
			connect: 'lower',
			tooltips: wNumb({
				decimals: decimals,
				thousand: ','
			})
		}).on('update',function(value,handle){
			values[slider.param] = Number(value[handle]).toFixed(decimals);
			result.innerHTML = values[slider.param];
		});

		container.on('click','button',event => {
			const {target} = event;
			event.preventDefault();
			console.log('updated');
			rangeField.noUiSlider.set(Number(values[slider.param]) + (slider.step * (target.textContent.trim() === '+' ? 1 : -1)));
		});


		fields.appendChild(control);
	});

	

	selectEngine(engine);
	
	domWrap(calc)
		.on('click','[engine]',event => {
			engine = event.target.getAttribute('engine');
			selectEngine(engine);
		})
		.on('click','.calculate', getResults);

	getResults();

	function selectEngine(engine) {
		[...calc.parentNode.querySelectorAll('[engine="'+engine+'"]')].forEach(element => domWrap(element).setSelected());
	}

	function itemString(num,format,append){
		return (format ? format.to(num) : num) + ' ' + append;
	}

	function getResults(){
		calculateResults({engine:engine, defConsumption:values.averageDEFConsumed / 100,mileage:values.annualMileage * 1000, ...values})
			.then(res => results.innerHTML = (
					h('div',
						h('div',
							h('h2',dollars.to(Math.abs(res.annualDieselCost17 - res.annualDieselCost14)))
							('h6','Fuel Cost Savings')
						)
						('div',
							h('h2',dollars.to((res.annualDEFCost17 - res.annualDEFCost14)))
							('h6','DEF Cost Increase')
						)
						('div',
							h('h2',dollars.to(Math.abs(res.annualFluidCost14 - res.annualFluidCost17)))
							('h6','Total Cost savings')
						)
					)
					('table',
						h('thead',h('tr',
							h('td')
							('td',h('h4','ghg14'))
							('td',h('h4','ghg17'))
						))
						('tbody',
							[
								['Avg Fuel Economy',values.averageMPG,res.DEFeconomny17,'MPG'],
								['Avg Def Consumption',values.averageDEFConsumed,res.DEFconsumption17 * 100,'',false,percent],
								['Annual Diesel Consumption',res.annualDieselConsumption14,res.annualDieselConsumption17,'gal',thousands,thousands],
								['Annual DEF Consumption',res.annualDEFConsumption14,res.annualDEFConsumption17,'gal',thousands,thousands],
								['Annual Fuel Cost',res.annualDieselCost14,res.annualDieselCost17,'',dollars,dollars],
								['Annual DEF Cost',res.annualDEFCost14,res.annualDEFCost17,'',dollars,dollars],
								['Annual Fluid Cost',res.annualFluidCost14,res.annualFluidCost17,'',dollars,dollars]
							].reduce(function(html,item){
								return html + h('tr',
									h('td',item[0])
									('td', itemString(item[1],item[4],item[3]))
									('td', itemString(item[2],item[5],item[3]))
								);
							},'')
						)
					)
				)
			);
	}

};